"use client";

import * as React from "react";
import Cropper from "react-easy-crop";
import { CropperUIProps, AVATAR_CONFIG } from "@US";

/**
 * Componente UI para o cropper e slider de zoom.
 * @param {CropperUIProps} props - Props de controle do Cropper.
 * @returns {JSX.Element} A interface do cropper.
 */
export function CropperUI({
  image,
  crop,
  zoom,
  onCropChange,
  onZoomChange,
  onCropComplete,
}: CropperUIProps) {
  return (
    <>
      <div className="relative w-full aspect-square bg-black">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={AVATAR_CONFIG.CROP_ASPECT_RATIO}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onCropComplete={onCropComplete}
        />
      </div>

      <div className="flex justify-between items-center mt-4">
        <input
          type="range"
          min={AVATAR_CONFIG.ZOOM_RANGE.min}
          max={AVATAR_CONFIG.ZOOM_RANGE.max}
          step={AVATAR_CONFIG.ZOOM_RANGE.step}
          value={zoom}
          onChange={(e) => onZoomChange(+e.target.value)}
          className="w-full mr-4"
        />
      </div>
    </>
  );
}
